import { render, staticRenderFns } from "./WarningLayout.vue?vue&type=template&id=68c2ad7c&scoped=true&"
import script from "./WarningLayout.vue?vue&type=script&lang=ts&"
export * from "./WarningLayout.vue?vue&type=script&lang=ts&"
import style0 from "./WarningLayout.vue?vue&type=style&index=0&id=68c2ad7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c2ad7c",
  null
  
)

export default component.exports